import React from 'react';
import PropTypes from 'prop-types';
import { loginWithGoogleEventEmitterFedcm } from './LoginUtils';
// import s from './Login.scss';

class GoogleFedCMLogin extends React.Component {
  static propTypes = {
    onGoogleLoginCallback: PropTypes.func,
  };

  static defaultProps = {
    onGoogleLoginCallback: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      googleClientId:
        '103703403489-b4t4lt8mr05brqpcdrmsu0di54cmjv4f.apps.googleusercontent.com',
    };
    this.btnRef = React.createRef();
  }

  handleCredentialResponse = response => {
    // Call custom onGoogleLoginCallback if provided
    if (this.props.onGoogleLoginCallback) {
      this.props.onGoogleLoginCallback();
    }

    // this.props.loginWithGoogle(this.state.googleClientId, response.credential);
    loginWithGoogleEventEmitterFedcm(
      response.credential,
      this.state.googleClientId,
    );
  };

  componentDidMount() {
    // Initialize Google Sign-In
    if (
      window.google?.accounts?.id &&
      typeof window.google.accounts.id.initialize === 'function' &&
      typeof window.google.accounts.id.renderButton === 'function'
    ) {
      window.google.accounts.id.initialize({
        client_id: this.state.googleClientId,
        callback: this.handleCredentialResponse,
        auto_select: true,
        use_fedcm_for_prompt: false,
        use_fedcm_for_button: true,
      });
      // window.google.accounts.id.renderButton(
      //   document.getElementById('gis-signin-button'),
      //   {
      //     theme: 'outline',
      //     size: 'large',
      //     width: this.props.isMobile ? '320' : '348',
      //   }, // customization attributes
      // );

      const btn = this.btnRef.current;
      const btnWidth = btn.offsetWidth;

      // Wait for iframe to load before removing padding
      const iframe = btn.querySelector('iframe');
      if (iframe) {
        iframe.onload = () => {
          const iframeDoc =
            iframe.contentDocument || iframe.contentWindow.document;
          const el = iframeDoc?.getElementById('container-div');
          if (el) el.style.padding = '0';
        };
      }

      // Render Google Sign-in button
      window.google.accounts.id.renderButton(
        btn,
        {
          theme: 'outline',
          size: 'large',
          width: btnWidth,
          // width: this.props.isMobile ? '320' : '348',
        }, // customization attributes
      );
      document.cookie =
        'g_state=; Path=/; Expires=Thu, 01 Jan 1900 00:00:01 GMT;';
    }
  }
  render() {
    return <div ref={this.btnRef} className="gis-signin-button" />;
  }
}

export default GoogleFedCMLogin;
